import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-empty-ticket-message',
  standalone: true,
  imports: [CommonModule, MatButtonModule, RouterLink],
  templateUrl: './empty-ticket-message.component.html',
  styleUrls: ['./empty-ticket-message.component.scss'],
})
export class EmptyTicketMessageComponent {}
